import { render, staticRenderFns } from "./WorkerTable.vue?vue&type=template&id=27147e0a"
import script from "./WorkerTable.vue?vue&type=script&lang=js"
export * from "./WorkerTable.vue?vue&type=script&lang=js"
import style0 from "./WorkerTable.vue?vue&type=style&index=0&id=27147e0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./WorkerTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports